import request from 'utils/request';

const PREFIX = '/api/aff-billing-app/';

export const AffSendingBillingApplicationAPI = {
  LIST: PREFIX + 'list',
  ADD: PREFIX + 'add',
  UPDATE: PREFIX + 'update',
  DELETE: PREFIX + 'delete?id=',
  DOWNLOAD: PREFIX + 'download',
  CHANGE_STATUS: PREFIX + 'status-change',
  PREVIEW: PREFIX + 'preview',
};

export function getAffSendingBillingApplicationList(data) {
  return request({
    url: AffSendingBillingApplicationAPI.LIST,
    method: 'post',
    data,
  });
}

export function addAffSendingBillingApplication(data) {
  return request({
    url: AffSendingBillingApplicationAPI.ADD,
    method: 'post',
    data,
  });
}

export function deleteAffSendingBillingApplication(id) {
  return request({
    url: AffSendingBillingApplicationAPI.DELETE + id,
    method: 'delete',
  });
}

export function updateAffSendingBillingApplication(data) {
  return request({
    url: AffSendingBillingApplicationAPI.UPDATE,
    method: 'put',
    data,
  });
}

export function changeAffSendingBillingApplicationStatus(data) {
  return request({
    url: AffSendingBillingApplicationAPI.CHANGE_STATUS,
    method: 'post',
    data,
  });
}

export function getAffBillingAppPreviewData(data) {
  return request({
    url: AffSendingBillingApplicationAPI.PREVIEW,
    method: 'post',
    data,
  });
}
